import { useState, useEffect } from 'react';
import api from '../api/client';

export default function Settings() {
  const [settings, setSettings] = useState({});
  const [form, setForm] = useState({
    whatsapp_token: '', whatsapp_phone_number_id: '', whatsapp_business_account_id: '',
    shopify_api_key: '', shopify_api_secret: '', shopify_store_url: '',
    twilio_account_sid: '', twilio_auth_token: '',
  });
  const [saved, setSaved] = useState(false);
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ nombre: '', email: '', password: '' });

  useEffect(() => {
    api.get('/settings').then((res) => setSettings(res.data));
    api.get('/users').then((res) => setUsers(res.data));
  }, []);

  const handleSaveSettings = async (e) => {
    e.preventDefault();
    const payload = {};
    Object.entries(form).forEach(([k, v]) => { if (v) payload[k] = v; });
    await api.put('/settings', payload);
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
    setForm({ whatsapp_token: '', whatsapp_phone_number_id: '', whatsapp_business_account_id: '', shopify_api_key: '', shopify_api_secret: '', shopify_store_url: '', twilio_account_sid: '', twilio_auth_token: '' });
    api.get('/settings').then((res) => setSettings(res.data));
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    try {
      await api.post('/users', newUser);
      setNewUser({ nombre: '', email: '', password: '' });
      api.get('/users').then((res) => setUsers(res.data));
    } catch (err) {
      alert(err.response?.data?.error || 'Error');
    }
  };

  const handleDeactivate = async (id) => {
    if (!window.confirm('Desactivar este usuario?')) return;
    await api.put(`/users/${id}/deactivate`);
    api.get('/users').then((res) => setUsers(res.data));
  };

  const inputStyle = { width: '100%', padding: 10, border: '1px solid #ddd', borderRadius: 4, marginBottom: 12, boxSizing: 'border-box', fontSize: 13 };

  const registerWebhooks = async () => {
    try {
      await api.post('/settings/register-shopify-webhooks');
      alert('Webhooks registrados en Shopify');
    } catch {
      alert('Error al registrar webhooks. Verifica las credenciales.');
    }
  };

  return (
    <div>
      <h1>Configuracion</h1>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, alignItems: 'start' }}>

        {/* WhatsApp Config */}
        <form onSubmit={handleSaveSettings} style={{ background: '#fff', borderRadius: 8, padding: 24 }}>
          <h3 style={{ marginTop: 0 }}>WhatsApp Cloud API</h3>
          {saved && <div style={{ background: '#d4edda', padding: 8, borderRadius: 4, marginBottom: 12, fontSize: 13 }}>Guardado</div>}
          <label style={{ fontSize: 12 }}>Token de acceso {settings.whatsapp_token && <span style={{color:'#888'}}>(configurado)</span>}</label>
          <input style={inputStyle} value={form.whatsapp_token} onChange={(e) => setForm({ ...form, whatsapp_token: e.target.value })} placeholder="EAAx..." />
          <label style={{ fontSize: 12 }}>Phone Number ID {settings.whatsapp_phone_number_id && <span style={{color:'#888'}}>(configurado)</span>}</label>
          <input style={inputStyle} value={form.whatsapp_phone_number_id} onChange={(e) => setForm({ ...form, whatsapp_phone_number_id: e.target.value })} />
          <label style={{ fontSize: 12 }}>Business Account ID {settings.whatsapp_business_account_id && <span style={{color:'#888'}}>(configurado)</span>}</label>
          <input style={inputStyle} value={form.whatsapp_business_account_id} onChange={(e) => setForm({ ...form, whatsapp_business_account_id: e.target.value })} />

          <h3>Shopify</h3>
          <label style={{ fontSize: 12 }}>Store URL {settings.shopify_store_url && <span style={{color:'#888'}}>({settings.shopify_store_url})</span>}</label>
          <input style={inputStyle} value={form.shopify_store_url} onChange={(e) => setForm({ ...form, shopify_store_url: e.target.value })} placeholder="tu-tienda.myshopify.com" />
          <label style={{ fontSize: 12 }}>API Key {settings.shopify_api_key && <span style={{color:'#888'}}>(configurado)</span>}</label>
          <input style={inputStyle} value={form.shopify_api_key} onChange={(e) => setForm({ ...form, shopify_api_key: e.target.value })} />
          <label style={{ fontSize: 12 }}>API Secret / Access Token {settings.shopify_api_secret && <span style={{color:'#888'}}>(configurado)</span>}</label>
          <input style={inputStyle} value={form.shopify_api_secret} onChange={(e) => setForm({ ...form, shopify_api_secret: e.target.value })} />

          <h3>Twilio Lookup (validación de números)</h3>
          <p style={{ fontSize: 11, color: '#888', marginTop: -8 }}>
            Verifica que un número sea móvil antes de mandarle WhatsApp. Costo ~$0.005 USD por lookup. Crea cuenta gratis en twilio.com (incluye $15 USD de crédito).
          </p>
          <label style={{ fontSize: 12 }}>Account SID {settings.twilio_account_sid && <span style={{color:'#888'}}>(configurado)</span>}</label>
          <input style={inputStyle} value={form.twilio_account_sid} onChange={(e) => setForm({ ...form, twilio_account_sid: e.target.value })} placeholder="ACxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx" />
          <label style={{ fontSize: 12 }}>Auth Token {settings.twilio_auth_token && <span style={{color:'#888'}}>(configurado)</span>}</label>
          <input style={inputStyle} value={form.twilio_auth_token} onChange={(e) => setForm({ ...form, twilio_auth_token: e.target.value })} placeholder="32 caracteres hex" />

          <div style={{ display: 'flex', gap: 10 }}>
            <button type="submit" style={{ padding: '10px 24px', background: '#4ecca3', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Guardar</button>
            <button type="button" onClick={registerWebhooks} style={{ padding: '10px 24px', background: '#3498db', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Registrar Webhooks</button>
          </div>
        </form>

        {/* Users */}
        <div style={{ background: '#fff', borderRadius: 8, padding: 24 }}>
          <h3 style={{ marginTop: 0 }}>Usuarios</h3>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 20 }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #eee', textAlign: 'left' }}>
                <th style={{ padding: 8 }}>Nombre</th><th>Email</th><th>Estado</th><th></th>
              </tr>
            </thead>
            <tbody>
              {users.map((u) => (
                <tr key={u.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: 8 }}>{u.nombre}</td>
                  <td>{u.email}</td>
                  <td>{u.activo ? <span style={{color:'#2ecc71'}}>Activo</span> : <span style={{color:'#888'}}>Inactivo</span>}</td>
                  <td>{u.activo && <button onClick={() => handleDeactivate(u.id)} style={{ background: 'none', border: 'none', color: '#e74c3c', cursor: 'pointer', fontSize: 12 }}>Desactivar</button>}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h4>Agregar usuario</h4>
          <form onSubmit={handleCreateUser}>
            <input style={inputStyle} placeholder="Nombre" value={newUser.nombre} onChange={(e) => setNewUser({ ...newUser, nombre: e.target.value })} required />
            <input style={inputStyle} placeholder="Email" type="email" value={newUser.email} onChange={(e) => setNewUser({ ...newUser, email: e.target.value })} required />
            <input style={inputStyle} placeholder="Password" type="password" value={newUser.password} onChange={(e) => setNewUser({ ...newUser, password: e.target.value })} required />
            <button type="submit" style={{ padding: '8px 20px', background: '#4ecca3', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer' }}>Crear usuario</button>
          </form>
        </div>
      </div>
    </div>
  );
}
